<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered.has-text-dark
          .column
            h1.is-size-3 Artículos de Sistemas
              | 
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns.is-centered.has-text-dark
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verTodo || verAlmacen")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-tags.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Artículos en Almacenes
            br
            router-link.a.button.is-dark.is-rounded.is-size-6(to="/Inventario/Sistemas/Almacenes") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verTodo || verSistemas")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-users.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Artículos Asignados
            br
            a.button.is-dark.is-rounded(@click="goAsignacionesArea('s')") Entrar
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'SubMenuSistemas',
    components: { Loader, NavBarInventario },
    data() {
      return {
        isLoading: false,
        verTodo: false,
        verAlmacen: false,
        verSistemas: false,
      }
    },
    methods: {
      iniciarComponente() {
        switch (this.userLogin.cargo) {
          case '000':
            this.verTodo = true
            break
          case '002':
            this.verTodo = true
            break
          case '2100':
            this.verTodo = true
            break
          case '003':
            this.verTodo = true
            break
          case '210':
            return false
          case '230':
            this.verTodo = true
          case '330':
            this.verTodo = true
            break
          case '331':
            this.verTodo = true
          break
          case '332':
            this.verTodo = true
          break
          case '160':
            return false
            break
          case '240':
            return false
            break
          case '241':
            return false
            break
          case '310':
            return false
            break
          case '321':
            return false
            break
          case '323':
            break
          case '324':
            break
          case '341':
            return false
            break
          case '342':
            return false
            break
          case '343':
            return false
            break
          case '350':
            return false
            break
          case '250':
            return false
            break
          case '370':
            return false
            break
          case '270':
            return false
            break
          default:
            this.verTodo = false
            this.verSistemas = false
            this.verAlmacen = false
            break
        }
      },
      goAsignacionesArea(area) {
        this.$store.commit('showAreaAsignacion', area)
        this.$router.push('/Inventario/Asignaciones')
      },
      backPage () {
        this.$router.back()
      },
    },
    computed: {
    ...mapState(['logueado', 'userLogin'])
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
  .card-item:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
</style>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/SubMenuSistemas.vue